import { Injectable } from '@angular/core';

@Injectable()
export class LanguageLocaleService {
  localeImports_sk() {
    return [
      import('@angular/common/locales/sk'),
      import('@angular/common/locales/extra/sk'),
      import('dayjs/locale/sk')
    ];
  }

  localeImports_cs() {
    return [
      import('@angular/common/locales/cs'),
      import('@angular/common/locales/extra/cs'),
      import('dayjs/locale/cs')
    ];
  }

  localeImports_pl() {
    return [
      import('@angular/common/locales/pl'),
      import('@angular/common/locales/extra/pl'),
      import('dayjs/locale/pl')
    ];
  }

  localeImports_de() {
    return [
      import('@angular/common/locales/de'),
      import('@angular/common/locales/extra/de'),
      import('dayjs/locale/de')
    ];
  }

  localeImports_es() {
    return [
      import('@angular/common/locales/es'),
      import('@angular/common/locales/extra/es'),
      import('dayjs/locale/es')
    ];
  }

  localeImports_sl() {
    return [
      import('@angular/common/locales/sl'),
      import('@angular/common/locales/extra/sl'),
      import('dayjs/locale/sl')
    ];
  }

  localeImports_ar() {
    return [
      import('@angular/common/locales/ar'),
      import('@angular/common/locales/extra/ar'),
      import('dayjs/locale/ar')
    ];
  }

  localeImports_en_GB() {
    return [
      import('@angular/common/locales/en-GB'),
      import('@angular/common/locales/extra/en-GB'),
      import('dayjs/locale/en-gb')
    ];
  }

  localeImports_en() {
    return [
      import('@angular/common/locales/en'),
      import('@angular/common/locales/extra/en'),
      import('dayjs/locale/en')
    ];
  }

  localeImports_pt() {
    return [
      import('@angular/common/locales/pt'),
      import('@angular/common/locales/extra/pt'),
      import('dayjs/locale/pt')
    ];
  }

  localeImports_hu() {
    return [
      import('@angular/common/locales/hu'),
      import('@angular/common/locales/extra/hu'),
      import('dayjs/locale/hu')
    ];
  }
}
